import { styled } from "@mui/system";

export const PageHeader = styled("div")`
  display: flex;
  justify-content: space-between;
`;
